export const ApiResponseMessages = {
    SECTION_SENT_REWORK: "Sections sent for rework.",
    REPORT_GENERATION_INITIATED: "Report generation has been initiated. Please check the status after some time.",
    SECTION_UPDATED: "Section updated successfully.",
    FAILED_TO_UPDATE_SECTION: "Failed to update section.",
    SECTION_ADDED:'Section added successfully.',
    FAILED_TO_ADD_SECTION:'Failed to add section.',
    SECTION_DELETED :'Section deleted successfully.',
    FAILED_TO_DELETE_SECTION:'Failed to delete section.',
    NO_REPORT_FOUND:'No reports found.',
    FAILED_TO_DELETE_REPORT:'Failed to delete report.'
  };